
import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import useTranslation from '../../../Hooks/UseTranslation'
import { useProgrammation } from '../../../Hooks/UseProgrammation'

// import ToggleGroupIcon from '@/Components/AnimatedIcons/ToggleGroupIcon/ToggleGroupIcon'
import Check from '@/Components/SvgImages/Check'

import './WorksList.scss'

interface Props {
  items: any[]
}

const WorksList = ({ items }: Props) => {

  const { t } = useTranslation();

  const { openItem } = useProgrammation()

  const [ isOpen, setIsOpen ] = useState(true)

  const [ restrictions, setRestrictions ] = useState('')

  const getAllRestrictions = (): any => {

    let checked = 0
    let all = 0

    items.forEach((work: any) => {

      if (work.restrictions.length) {

        all += work.restrictions.length

        work.restrictions.forEach((restriction: any) => {

          if (restriction.checked) {

            checked += 1
          }
        })
      }
    })

    if (all === 0) {

      return ''
    }

    return `${checked}/${all}`
  }

  const getWorkRestrictions = (work: any) => {

    let checked = 0
    let all = 0

    work.restrictions.forEach((restriction: any) => {

      if (restriction.checked) {

        checked += 1
      }
      all += 1
    })

    if (all === 0) {

      return null
    }

    return (
      <span className={`restrictions ${checked === all ? 'all-closed' : 'still-open'}`}>
        {`(${checked}/${all})`}
      </span>
    )
  }

  useEffect(() => {

    setRestrictions(getAllRestrictions())
  }, [ items ])

  return (
    <div className="works-list">
      <div className="body"
        // style={{ height: isOpen ? (items.length * 23) : 0 }}
      >
        {items.map((work: any) => (
          <div key={work._id}
            className="work-item"
            onClick={(e: any) => {
              e.stopPropagation()
              e.preventDefault()

              openItem(work._id)
            }}
          >
            {work.colorCode && (
              <div className="color-code" style={{ backgroundColor: work.colorCode.color }}></div>
            )}
            <div className="name"
              style={{
                color: work.status === 'completada' ? '#9fa1a0' : '#000',
              }}
            >
              {work.name}
            </div>
            <div className="constraints">
              {getWorkRestrictions(work)}
            </div>
            <div style={{ marginLeft: '.5rem', paddingBottom: 2, width: 20 }}>
              {work.status === 'completada' && (
                <Check width={18} height={18} />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default WorksList
